import { useState } from 'react'
import useItemSelector, { ItemSelectorInit } from './useItemSelector'

export default function useItemSelection<ITEM extends { uuid: string }, BASE extends { uuid: string }>(
  init: ItemSelectorInit<ITEM, BASE>,
  options: BASE[]
) {
  const [items, setItems] = useState<ITEM[]>([])

  return useItemSelector(init, items, setItems, options)
}
